import type {
  EquipmentVendorCreateApiData,
  EquipmentVendorCreateApiResponses,
  EquipmentVendorDeleteApiData,
  EquipmentVendorDeleteApiResponses,
  EquipmentVendorGetApiData,
  EquipmentVendorGetApiResponses,
  EquipmentVendorListApiData,
  EquipmentVendorListApiResponses,
  EquipmentVendorPatchApiData,
  EquipmentVendorPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const equipmentVendorUrls = {
  getPaginatedEquipmentVendors: dataEndpoint<EquipmentVendorListApiData, EquipmentVendorListApiResponses>({
    getUrl: (queryParams) => apiUrl('inventory/equipment-vendors/', queryParams)
  }),
  getEquipmentVendor: dataEndpoint<EquipmentVendorGetApiData, EquipmentVendorGetApiResponses>({
    getUrl: ({ equipmentVendorId }) => apiUrl(`inventory/equipment-vendors/${equipmentVendorId}/`)
  }),
  postEquipmentVendor: responseEndpoint<EquipmentVendorCreateApiData, EquipmentVendorCreateApiResponses>({
    getUrl: () => apiUrl('inventory/equipment-vendors/'),
    getBody: (data) => data
  }),
  patchEquipmentVendor: responseEndpoint<EquipmentVendorPatchApiData, EquipmentVendorPatchApiResponses>({
    getUrl: ({ equipmentVendorId }) => apiUrl(`inventory/equipment-vendors/${equipmentVendorId}/`),
    getBody: ({ equipmentVendorId: _, ...body }) => body
  }),
  deleteEquipmentVendor: dataEndpoint<EquipmentVendorDeleteApiData, EquipmentVendorDeleteApiResponses>({
    getUrl: ({ equipmentVendorId }) => apiUrl(`inventory/equipment-vendors/${equipmentVendorId}/`)
  })
};
